import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link as ScrollLink } from 'react-scroll';

import imgDownArrow from 'src/assets/images/DownArrow.svg';

const DownArrow = props => {
  return (
    <Root
      {...props}
      to="downarrow"
      offset={35}
      smooth
      style={{
        position: 'absolute',
        left: '50%',
        bottom: '-35px',
        width: '64px',
        height: '70px',
        transform: 'translate(-50%)',
      }}
      id="downarrow"
    />
  );
};

export default DownArrow;

const animateArrow = keyframes`
  0% {
    transform: translate(-50%, -50%);
  }
  100% {
    transform: translate(-50%, 260%);
  }
`;

const Root = styled(ScrollLink)`
  position: absolute;
  bottom: -25px;
  background-color: ${({ theme }) => theme.colorPrimary};
  width: 64px;
  height: 70px;
  &::after {
    content: '';
    background-image: url(${imgDownArrow});
    width: 27px;
    height: 14px;
    position: absolute;
    top: 13px;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: ${animateArrow} 2s infinite;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DownArrow.js